import { Injectable } from '@angular/core';

import { APIService } from '@fry/lib/api';
import { ApiStore, DBDoc } from '@fry/lib/store';

import { AsyncTask } from './async-task';
import { catchError, map, tap } from 'rxjs/operators';
import { guid } from '@fry/lib/utils';
import { AsyncTaskDoc, AsyncTaskOutputSummary, AsyncTaskStates} from './async-task.interface';
import { Observable, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AsyncTasksStore extends ApiStore<AsyncTask, AsyncTaskDoc> {
    AssociatedModel = AsyncTask

    docType = 'celeryTask';
    endpoint = 'async-tasks';

    constructor(
      api: APIService,
    ) {
      super(api);
    }

    public blank(defaults?: Partial<DBDoc>): AsyncTask {
      const doc: AsyncTaskDoc = {
        _id: guid(),
        state: AsyncTaskStates.DRAFT,
        ...(defaults || {})
      };
      return this.createObject(doc);
    }

    start(taskAction: string, data: any) {
      return this.api.post(`${this.endpoint}/start/${taskAction}`, data);
    }

    download(id: string) {
      return this.api.get(`${this.endpoint}/${id}/download`).pipe(
        map(result => {
          window.location.href = result.url;
        })
      );
    }

    public summary(oid: string): Observable<AsyncTaskOutputSummary> {
      return this.api.get(`${this.endpoint}/${oid}/output`)
        .pipe(
          catchError(error => {
            console.log('Received an error:', error);
            return throwError(() => new Error(error));
          }),
          tap(() => {
            this.invalidate();
          })
        );
    }

}
